import React, {FC} from 'react'
import {isEmpty} from 'lodash'
import {Clock, MenuEllipsis} from 'jbc-front/components/icons'
import {Todo} from 'features/procedures/Timeline/Todo'
import {dateFormat} from 'libs/formatter'
import type {ProcedureStatus} from 'types/api/procedureStatuses/procedureStatus'
import styles from '../Show.scss'

// @ts-ignore
import DropDownMenu from 'components/DropDownMenu'
// @ts-ignore
import {Progress as ProgressBar} from 'components/Progress'
// @ts-ignore
import {ListGroup, ListItem, ListTitle} from 'components/ListGroup'

export interface ProgressProps {
  procedureStatus: ProcedureStatus
}

export const Progress: FC<ProgressProps> = ({procedureStatus}) => (
  <>
    <ProgressBar progress={procedureStatus.progress} key="progress" className={styles.progressBar} large />
    進捗状況：{' '}
    <span className={styles.statusCount}>
      {procedureStatus.done_todos_count}/{procedureStatus.total_todos_count}
    </span>
    {procedureStatus.done_todos_count === procedureStatus.total_todos_count ? (
      <span className={styles.statusTag}>完了</span>
    ) : (
      <span className={styles.statusTag}>対応中</span>
    )}
  </>
)

interface ToggleProps {
  onClick: () => void
}

const Toggle: FC<ToggleProps> = ({onClick}) => (
  <a className={styles.todoMenu} onClick={onClick}>
    <MenuEllipsis size={20} />
  </a>
)

export interface MenuProps {
  menuItems: {
    label: string
    onClick: () => void
  }[]
}

export const Menu: FC<MenuProps> = ({menuItems}) => <DropDownMenu toggle={Toggle} menuItems={menuItems} />

export interface TodoListProps {
  procedureStatus: ProcedureStatus
  onTodoChange: (todoListNo: number, todoNo: number, todo: {status: string; title: string}) => void
}

export const TodoList: FC<TodoListProps> = ({procedureStatus, onTodoChange}) => (
  <>
    {procedureStatus.todo_lists?.map(
      (todoList, todoListNo) =>
        !isEmpty(todoList.todos) && (
          <ListGroup key={todoListNo}>
            <ListTitle>
              <div>
                {todoList.title}
                {todoList.due_on && (
                  <span className={styles.todoDate}>
                    <Clock size={16} /> {dateFormat(todoList.due_on, 'MMMDo')}
                  </span>
                )}
              </div>
            </ListTitle>
            {todoList.todos?.map((todo, todoNo) => (
              <ListItem key={todoNo}>
                <Todo onTodoChange={onTodoChange} todoListNo={todoListNo} todoNo={todoNo} todo={todo} />
              </ListItem>
            ))}
          </ListGroup>
        )
    )}
  </>
)
